'use strict';

import { Menuhorizontal } from './menuhorizontal.js';

export class MenuhorizontalTop extends Menuhorizontal {
	constructor(component_key) {
		super(component_key);
		this.last_scroll_position = 0;
		this.last_scroll_direction = undefined;
		this.scroll_delta = undefined;
		this.sticky_visible = false;
	}

	add_events() {
		this.init_sticky_navigation();

		this.$root.on('click', '.js-link', (e) => {
			e.preventDefault();
			const $link = jQuery(e.currentTarget);
			const $item = $link.closest('.js-item');
			const section_id = $link.data('sectionid') || $item.data('sectionid');
			const url = $link.attr('href');

			if (!section_id) {
				if (url) {
					yalwa.basics.navigate(url);
				}
				return false;
			}

			const default_selected = this.$root.attr('data-default-selected') || this.$root.data('default-selected') || '';

			if (default_selected) {
				yalwa.basics.ga.event({
					category: 'htabs',
					action: 'actual_section_' + default_selected,
					label: 'clicked_section_' + section_id,
				});
			}

			if (section_id === 'dating') {
				yalwa.basics.ga.event({
					category: 'dating_promo',
					action: 'header tab'
				});
			}

			let navigated = false;
			const do_navigate = () => {
				if (!navigated) {
					navigated = true;
					if (url) {
						yalwa.basics.navigate(url);
					}
				}
			};

			const timeout_id = setTimeout(do_navigate, 150);

			yalwa.basics.ga.event({
				category: 'navigation_click',
				action: 'tab_' + section_id
			}).always(() => {
				clearTimeout(timeout_id);
				do_navigate();
			});

			return false;
		});
	}

	init_sticky_navigation() {
		const $main_col = jQuery('.js-main_col');
		if (!$main_col.length || yalwa.basics.get_routing() === 'dol_landing' || yalwa.basics.get_routing() === 'uhp') {
			return;
		}

		this.$root.addClass('menuhorizontal--stuck');
		this.sticky_visible = this.$root.hasClass('menuhorizontal--stuck');
		jQuery(window).on(
			'scroll.menuhorizontal_top_' + this.id,
			yalwa.basics.throttle(() => this.update_sticky_navigation(), 300)
		);
	}

	update_sticky_navigation() {
		if (yalwa.basics.scroll_is_locked()) {
			return;
		}

		const current_scroll_position = yalwa.mobile.mainscroll_get();
		if (current_scroll_position === this.last_scroll_position) {
			return;
		}

		if (current_scroll_position < 200) {
			if (!this.sticky_visible) {
				this.scrolling_sticky();
				this.sticky_visible = true;
			}
			this.last_scroll_position = current_scroll_position;
			return;
		}

		if (yalwa.vap) {
			if (!yalwa.v.deleted_ad) {
				this.scrolling_sticky_reset();
			}
			this.sticky_visible = false;
			this.last_scroll_position = current_scroll_position;
			return;
		}

		if ((current_scroll_position > this.last_scroll_position ? 'down' : 'up') === this.last_scroll_direction) {
			this.scroll_delta += Math.abs(current_scroll_position - this.last_scroll_position);
			if (this.scroll_delta > 100) {
				const show = this.last_scroll_direction === 'up';
				if ((show && !this.sticky_visible) || (!show && this.sticky_visible)) {
					if (show) {
						this.scrolling_sticky();
					} else {
						this.scrolling_sticky_reset();
					}
					this.sticky_visible = show;
					this.scroll_delta = 0;
				}
			}
		} else {
			this.scroll_delta = Math.abs(current_scroll_position - this.last_scroll_position);
		}

		this.last_scroll_direction = current_scroll_position > this.last_scroll_position ? 'down' : 'up';
		this.last_scroll_position = current_scroll_position;
	}

	scrolling_sticky() {
		yalwa.basics.show(jQuery('.js-narrow_search'));
		yalwa.basics.hide(jQuery('.js-email_alert_dialog_fixed'));
		this.$root.addClass('menuhorizontal--stuck').velocity(
			{
				translateY: [0, -75],
				translateZ: 0
			},
			{
				duration: 270,
				display: 'flex'
			}
		);
	}

	scrolling_sticky_reset() {
		yalwa.basics.hide(jQuery('.js-narrow_search'));
		yalwa.basics.show(jQuery('.js-email_alert_dialog_fixed'));
		this.$root.removeClass('menuhorizontal--stuck').velocity(
			{
				translateY: -75,
				translateZ: 0
			},
			{
				duration: 270,
				display: 'flex'
			}
		);
	}
}
